class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack};
/* tjs <- get-css-var.ts */

/* line 1 */
export function getCssVar(variableName, atElement = document.body) {
  try {
  __tjs.pushStack('get-css-var.ts:4:getCssVar');
  if (variableName instanceof Error) return variableName;
  if (atElement instanceof Error) return atElement;
  if (typeof variableName !== 'string') return __tjs.typeError('get-css-var.ts:4:getCssVar.variableName', 'string', variableName);

    const computedStyle = getComputedStyle(atElement);
    if (variableName.endsWith(')') && variableName.startsWith('var(')) {
        variableName = variableName.slice(4, -1);
    }
    return computedStyle.getPropertyValue(variableName).trim();

  } finally { __tjs.popStack(); }
}
getCssVar.__tjs = {
  "params": {
    "variableName": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "atElement": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "get-css-var.ts:4"
}